const queries = {
  hover: '(hover: hover)',
  md: '(min-width: 30rem)',
  lg: '(min-width: 64rem)',
  xl: '(min-width: 100rem)',
} as const;

export default queries;
